import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
	IIdentificationProps,
	IIdentificationResponse,
	ShiftOptions,
} from 'models/ICattlesData'
import cattlesApiServices from 'services/cattlesApiServices'
interface useIdentificationProps {
	page: number
	pageSize: number
	shift?: ShiftOptions
	gate: number
	date?: number
	cameraId: number
	isEnabled: boolean
}

export const useIdentification = (props: useIdentificationProps) => {
	const queryProps: IIdentificationProps = {
		rec_date: props.date,
		camera_id: props.cameraId,
		day_period: props.shift,
		page: props.page,
		page_size: props.pageSize,
	}
	const identificationQuery = useQuery<IIdentificationResponse, AxiosError>({
		queryKey: ['identificationList', queryProps],
		queryFn: () => cattlesApiServices.getIdentificationList(queryProps),
		staleTime: 50000,
		retry: 1,
		enabled: props.isEnabled,
	})

	return { ...identificationQuery }
}
